import { BatchItems } from './chunk-OCJFRG6N.js';
import { ProtocolIcon } from './chunk-O4MOSOS2.js';
import { CHAINLINK_AUTOMATION, AUTOMATION_COMPONENTS, fieldAtPath, legField, decodedOrRaw, AUTOMATION_FIELD_LABELS, ProtocolValue, ProtocolBadge, SectionCard, FactGrid, ProtocolParamList } from './chunk-GP2K77BU.js';
import { Cog } from 'lucide-react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function asList(value) {
  return Array.isArray(value) ? value : [];
}
function ChainlinkAutomationTransmit({ call, hint }) {
  const report = fieldAtPath(call.params, "rawReport", "report", "encodedReport");
  const fastGasWei = legField(report, "fastGasWei");
  const linkNative = legField(report, "linkNative");
  const linkUsd = legField(report, "linkUSD");
  const upkeepIds = asList(decodedOrRaw(legField(report, "upkeepIds")));
  const gasLimits = asList(decodedOrRaw(legField(report, "gasLimits")));
  const triggers = asList(decodedOrRaw(legField(report, "triggers")));
  const performDatas = asList(decodedOrRaw(legField(report, "performDatas")));
  const lengths = [upkeepIds, gasLimits, triggers, performDatas].map((a) => a.length);
  const aligned = lengths[0] > 0 && lengths.every((n) => n === lengths[0]);
  const count = aligned ? upkeepIds.length : 0;
  const reportFacts = [
    {
      label: AUTOMATION_FIELD_LABELS.registry,
      value: call.address != null ? /* @__PURE__ */ jsx(ProtocolValue, { value: call.address }) : void 0,
      when: call.address
    },
    { label: AUTOMATION_FIELD_LABELS.fastGasWei, value: /* @__PURE__ */ jsx(ProtocolValue, { value: fastGasWei }), when: fastGasWei != null },
    { label: "LINK / USD (raw)", value: /* @__PURE__ */ jsx(ProtocolValue, { value: linkUsd }), when: linkUsd != null },
    { label: AUTOMATION_FIELD_LABELS.linkNative, value: /* @__PURE__ */ jsx(ProtocolValue, { value: linkNative }), when: linkNative != null }
  ];
  const title = /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
    /* @__PURE__ */ jsx(ProtocolIcon, { protocolId: CHAINLINK_AUTOMATION.protocolId, icon: Cog }),
    /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: hint.label ?? call.label ?? "transmit" })
  ] });
  const meta = /* @__PURE__ */ jsxs(Fragment, { children: [
    count > 0 && /* @__PURE__ */ jsxs("span", { className: "text-2xs text-muted-foreground", children: [
      count,
      " ",
      count === 1 ? "upkeep" : "upkeeps"
    ] }),
    /* @__PURE__ */ jsx(ProtocolBadge, { protocolId: CHAINLINK_AUTOMATION.protocolId })
  ] });
  return /* @__PURE__ */ jsxs(SectionCard, { title, protocolId: CHAINLINK_AUTOMATION.protocolId, meta, children: [
    /* @__PURE__ */ jsx("p", { className: "mb-2 text-xs text-muted-foreground", children: "Reported upkeep inputs; execution outcomes are recorded separately." }),
    !aligned && lengths.some((n) => n > 0) && /* @__PURE__ */ jsx("p", { className: "mb-2 text-xs text-muted-foreground", children: "Report arrays do not align. Fields remain unpaired below." }),
    count > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(FactGrid, { facts: reportFacts }),
      /* @__PURE__ */ jsx("div", { className: "mt-2 space-y-2", children: /* @__PURE__ */ jsx(BatchItems, { items: upkeepIds, noun: "Upkeep", renderItem: (_, i) => /* @__PURE__ */ jsx(
        FactGrid,
        {
          facts: [
            { label: AUTOMATION_FIELD_LABELS.upkeepId, value: /* @__PURE__ */ jsx(ProtocolValue, { value: upkeepIds[i] }), when: upkeepIds[i] != null },
            { label: AUTOMATION_FIELD_LABELS.gasLimit, value: /* @__PURE__ */ jsx(ProtocolValue, { value: gasLimits[i] }), when: gasLimits[i] != null },
            { label: AUTOMATION_FIELD_LABELS.trigger, value: /* @__PURE__ */ jsx(ProtocolValue, { value: triggers[i] }), when: triggers[i] != null },
            { label: AUTOMATION_FIELD_LABELS.performData, value: /* @__PURE__ */ jsx(ProtocolValue, { value: performDatas[i] }), when: performDatas[i] != null }
          ]
        }
      ) }) })
    ] }) : (
      // No report decoded into the expected arrays: fall back to the generic
      // argument list rather than an empty card.
      /* @__PURE__ */ jsx(ProtocolParamList, { params: call.params, emptyLabel: "No decoded arguments" })
    ),
    /* @__PURE__ */ jsxs("details", { className: "mt-3 min-w-0", children: [
      /* @__PURE__ */ jsx("summary", { className: "cursor-pointer text-xs text-muted-foreground hover:text-foreground", children: "All call arguments" }),
      /* @__PURE__ */ jsx("div", { className: "pt-2", children: /* @__PURE__ */ jsx(ProtocolParamList, { params: call.params, emptyLabel: "No decoded arguments" }) })
    ] })
  ] });
}

// src/protocols/chainlink_automation/index.ts
var PID = CHAINLINK_AUTOMATION.protocolId;
var CHAINLINK_AUTOMATION_HINTS = {
  valueHints: [],
  eventHints: [],
  callHints: [
    { protocolId: PID, call: "transmit", component: AUTOMATION_COMPONENTS.transmit, summaryFields: [] }
  ]
};
function registerChainlinkAutomation(registry) {
  registry.registerCall(AUTOMATION_COMPONENTS.transmit, ChainlinkAutomationTransmit);
  registry.registerHints(CHAINLINK_AUTOMATION_HINTS);
  return registry;
}

export { CHAINLINK_AUTOMATION_HINTS, ChainlinkAutomationTransmit, registerChainlinkAutomation };
//# sourceMappingURL=chunk-GYUR5GMU.js.map
//# sourceMappingURL=chunk-GYUR5GMU.js.map